goog.provide("shadow.js.shim.module$src$svg$inform$bubble_left_svg");
goog.provide("module$shadow_js_shim_module$src$svg$inform$bubble_left_svg");
shadow.js.shim.module$src$svg$inform$bubble_left_svg = shadow.js.nativeProvides["src/svg/inform/bubble-left.svg"] = shadow$bridge("src/svg/inform/bubble-left.svg");
module$shadow_js_shim_module$src$svg$inform$bubble_left_svg.default = shadow.js.shim.module$src$svg$inform$bubble_left_svg;
